// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"386":"8a1417f6","540":"cd069834","652":"4aadf2b9","667":"fb6b4dbc","867":"05ca8dc3"}[chunkId] + ".chunk.css";
};